/* eslint-disable react/display-name */
import * as React from 'react';

const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g>
      <path
        d="M9.5,8,3.93,2.22a1.32,1.32,0,0,1,0-1.71L4,.4H4A1,1,0,0,1,5.65.4l6.52,6.74a2,2,0,0,1,.22.86,2,2,0,0,1-.22.86L5.65,15.6h0A1,1,0,0,1,4,15.6l-.11-.11a1.32,1.32,0,0,1,0-1.71Z"
        style={{ fill: 'inherit' }}
      />
    </g>
  </svg>
);

export default ChevronRight;
